import { Link } from "react-router-dom";
import { CalendarDays, MapPin, ArrowRight, Tag } from "lucide-react";

// Per-event RSVP breakdown grid with link to manage events.
export const EventsBreakdown = ({ events }) => (
  <div className="mt-14">
    <div className="flex items-baseline justify-between">
      <div>
        <div className="overline">Eventos ativos</div>
        <h2 className="display-heading text-2xl sm:text-3xl mt-2">Inscrições por evento.</h2>
      </div>
      <Link
        to="/admin/eventos"
        className="text-xs uppercase tracking-[0.18em] text-[hsl(var(--primary))] hover:underline inline-flex items-center gap-1"
        data-testid="dashboard-manage-events"
      >
        Gerir eventos <ArrowRight className="h-3 w-3" />
      </Link>
    </div>

    <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="dashboard-events-grid">
      {(events || []).length === 0 ? (
        <p className="text-sm text-[hsl(var(--muted-foreground))]">
          Ainda não há eventos ativos. Crie um em <Link to="/admin/eventos" className="text-[hsl(var(--primary))] underline">/admin/eventos</Link>.
        </p>
      ) : (
        (events || []).map((ev) => (
          <Link
            key={ev.slug}
            to={`/admin/inscricoes?event=${encodeURIComponent(ev.slug)}`}
            className="block bg-white border border-[hsl(var(--border))] p-5 hover:border-[hsl(var(--primary))] transition-colors"
            data-testid={`dashboard-event-card-${ev.slug}`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <h3 className="display-heading text-lg leading-tight">{ev.title}</h3>
                <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-[hsl(var(--muted-foreground))]">
                  {ev.date_str && (
                    <span className="inline-flex items-center gap-1">
                      <CalendarDays className="h-3 w-3 text-[hsl(var(--accent))]" />{ev.date_str}
                    </span>
                  )}
                  {ev.location && (
                    <span className="inline-flex items-center gap-1">
                      <MapPin className="h-3 w-3 text-[hsl(var(--accent))]" />{ev.location}
                    </span>
                  )}
                  {ev.price_eur > 0 && (
                    <span className="inline-flex items-center gap-1">
                      <Tag className="h-3 w-3 text-[hsl(var(--accent))]" />{Number(ev.price_eur).toFixed(0)} €
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-5 flex items-baseline gap-3">
              <div className="display-heading text-4xl text-[hsl(var(--primary))] tabular-nums">
                {ev.rsvp_count}
              </div>
              <div className="text-xs text-[hsl(var(--muted-foreground))]">
                {ev.rsvp_count === 1 ? "inscrito" : "inscritos"}
                {ev.rsvp_guests > 0 && ` · +${ev.rsvp_guests} acompanhantes`}
              </div>
            </div>
            {ev.price_eur > 0 && (
              <div className="mt-2 text-[11px] inline-flex items-center gap-1 px-2 py-0.5 bg-emerald-50 text-emerald-800 border border-emerald-200">
                ✓ {ev.rsvp_paid_count} pagos
              </div>
            )}
          </Link>
        ))
      )}
    </div>
  </div>
);
